import type { SubHeaderMenuItemType } from '#base/core/types/SubHeaderMenuItemType';

const items: SubHeaderMenuItemType[] = [];

items.push({
	icon: 'fa-envelope',
	text: 'Contact',
	to: {
		title: 'Contact opnemen met Fysio Hier',
		url: '/contact',
		newTab: false,
	},
});

export default items;
